import * as React from "react";

;
export const PopoverClose = (props: React.SVGProps<SVGSVGElement>) => <svg width={16} height={17} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={0.75} y={1.25} width={14.5} height={14.5} rx={3.25} stroke="#CFCDD3" strokeWidth={1.5} /><path d="M12 8.5l-6.75 3.897V4.603L12 8.5z" fill="#585265" /></svg>;